export default __webpack_public_path__ + "static/media/contactsRed.ba8953ea.svg";